"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockWebSocketConnection = void 0;
const inversify_1 = require("inversify");
const socketIo_1 = require("../../../../types/socketIo");
let MockWebSocketConnection = class MockWebSocketConnection {
    constructor() {
        // event scopes to listen on
        this.eventScopes = [];
    }
    /**
     * Set socket connection url and port.
     */
    setUrl(url, port) {
        // // connect to url
        // this.socket = new SocketIO(`${url}:${port}`, "");
        // // resubscribe to event scopes on socket reconnect
        // this.socket.on("connect", () => {
        //   this.resubscribe();
        // });
    }
    /**
     * Resubscribe socket to event scopes.
     */
    resubscribe() {
        // let socket subscribe to event scopes
        // HACK: styleguidist will try to subscribe to the web socket server while its closed
        // on initialization causing an error
        if (this.socket.readyState === socketIo_1.SocketIOStates.OPEN) {
            this.socket.emit("subscribe", JSON.stringify(this.eventScopes));
        }
    }
    /**
     * Run function on scope and event.
     */
    on(eventScope, event, func) {
        // ensure that this eventScope is registered
        if (this.eventScopes.indexOf(eventScope) === -1) {
            this.eventScopes.push(eventScope);
            this.resubscribe();
        }
        // listen to event scope and event to run function
        this.socket.on(`${eventScope}|${event}`, (data) => {
            // data will come down as a string
            func(JSON.parse(data));
        });
    }
    /**
     * Remove listening to scope and event.
     */
    off(eventScope, event) {
        this.socket.off(`${eventScope}|${event}`);
    }
    /**
     * Emit an event to the server with given data.
     */
    emit(event, ...args) {
        this.socket.emit(event, JSON.stringify(args));
    }
};
MockWebSocketConnection = __decorate([
    (0, inversify_1.injectable)()
], MockWebSocketConnection);
exports.MockWebSocketConnection = MockWebSocketConnection;
//# sourceMappingURL=MockWebSocketConnection.js.map